export default function withOptional(str: string, required: boolean): string {
  return required ? str : `${str} (Optional)`;
}
